module.exports = __webpack_public_path__ + "img/IT0000129818821.dd9f0dca.png";